module.exports = __webpack_public_path__ + "img/incubationBanner.daf37c4b.png";